<template>
    <div class="py-4">
        <modal-filter :onfilter="onfilter" :filter="filter" @onclose="onfilter = false" @onfilter="ONFILTER()"/>
        <modal-delete v-if="ondelete" :ondelete="ondelete" :id="id" @onclose="ondelete = false" @onreload="ONFILTER()"/>
        <modal-reload v-if="onreload" :onreload="onreload" :item="item" @onclose="onreload = false" @onreload="FRESH"/>
        <header>
            <div class="container-fluid">
                <div class="pb-4">
                    <div class="row align-items-end">
                        <div class="col-sm col-12">
                            <h1 class="h2 ls-tight">Manifiestos</h1>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <main>
            <div class="container-fluid">
                <div class="vstack gap-4">
                    <div class="d-flex flex-column flex-md-row gap-3 justify-content-between">
                        <form class="d-flex gap-3 row" @submit.prevent="FILTER()">
                            <div>
                                <button @click="onfilter = true" type="button" class="btn btn-h px-3 btn-neutral">
                                    <i class="bi bi-funnel me-2"></i>
                                    <span>Filtro</span>
                                    <span class="vr opacity-20 mx-3"></span>
                                    <span class="text-xs text-primary">{{ count_filter }}</span>
                                </button>
                            </div>
                            <div>
                                <button @click="SORT()" type="button" class="btn btn-h px-3 btn-neutral">
                                    <i class="me-2" :class="filter.sortDesc == 'ASC' ? 'bi bi-sort-alpha-up' : 'bi bi-sort-alpha-down-alt'"></i>
                                    <span>{{ filter.sortDesc }}</span>
                                </button>
                            </div>
                            <div class="col-md-4 px-0">
                                <div class="input-group input-group-sm input-group-inline">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text pe-2 text-sm"><i class="bi bi-search"></i></span>
                                    </div>
                                    <input type="text" class="form-control" placeholder="Buscar..." v-model="filter.search">
                                </div>
                            </div>
                            <div>
                                <button type="submit" class="btn btn-h px-3 btn-primary">
                                    <div class="spinner-border spinner-border-sm" role="status" v-if="loading == 'filter'">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <span v-else>Buscar</span>
                                </button>
                            </div>
                            <div>
                                <button type="button" class="btn btn-h px-3 btn-danger" @click="CLEAR()">
                                    <div class="spinner-border spinner-border-sm" role="status" v-if="loading == 'clear'">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <span v-else>Limpiar</span>
                                </button>
                            </div>
                        </form>
                    </div>
                    <div class="card">
                        <div class="card-header bg-white">
                            <h5 class="me-auto">Listado</h5>
                        </div>
                        <div class="card-body p-0">
                            <template>
                                <v-data-table  class="elevation-1"
                                    :headers="headers.filter( (e, i) => { if(role == 1){ return e }else{ if(i != 5){ return e } } })"
                                    :items="loading == 'table' || loading == 'sort' || loading == 'filter' || loading == 'clear' ? [] : items.data"
                                    :options.sync="options"
                                    :server-items-length="items.total"
                                    :loading="loading == 'table' || loading == 'sort' || loading == 'filter' || loading == 'clear'"
                                    :footer-props="{
                                        'items-per-page-options': [5, 10, 50, 100]
                                    }">
                                    <template v-slot:[`item.awb`]="{ item }">
                                        <router-link :to="{ name: 'AwbDetail', params: { awb: item.awb } }"
                                            class="text-decoration-none">
                                            {{ item.awb }}
                                        </router-link>
                                    </template>
                                    <template v-slot:[`item.state_id`]="{ item }">
                                        <span class="badge badge-dark badge-pill" v-if="item.state_id == 20">Cerrado</span>
                                        <span class="badge badge-success badge-pill" v-else>Abierto</span>
                                    </template>
                                    <template v-slot:[`item.created_at`]="{ item }">
                                        {{ item.created_at | DATE }}
                                    </template>
                                    <template v-slot:[`item.open`]="{ item }">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <a v-bind="attrs"
                                                    v-on="on">
                                                    <router-link
                                                        :to="{ name: 'AwbDetail', params: { awb: item.awb } }"
                                                        class="btn btn-info btn-m">
                                                        <small><i class="bi bi-card-list"></i></small>
                                                    </router-link>
                                                </a>
                                            </template>
                                            <small>Ver</small>
                                        </v-tooltip>
                                    </template>
                                    <template v-slot:[`item.delete`]="{ item }">
                                        <v-tooltip top v-if="globalViewOption('AwbDelete') && item.state_id != 20">
                                            <template v-slot:activator="{ on, attrs }">
                                                <button @click="DELETE(item.id)"
                                                    type="button"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    class="btn btn-danger btn-m">
                                                    <small><i class="bi bi-trash3"></i></small>
                                                </button>
                                            </template>
                                            <small>Eliminar</small>
                                        </v-tooltip>
                                        <button class="btn btn-danger btn-m" disabled v-else>
                                            <small><i class="bi bi-trash3"></i></small>
                                        </button>
                                    </template>
                                    <template v-slot:[`item.print`]="{ item, index }">
                                        <div class="d-flex gap-3">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <button @click="PRINT(item.awb, index)"
                                                        type="button"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        class="btn btn-neutral btn-m">
                                                        <small class="d-flex justify-content-center align-items-center">
                                                            <div class="spinner-border spinner-border-sm mb-0" role="status" v-if="print_wr.filter(e => e == index).length == 1">
                                                                <span class="sr-only">Loading...</span>
                                                            </div>
                                                            <i class="bi bi-printer" v-else></i>
                                                        </small>
                                                    </button>
                                                </template>
                                                <small>Imprimir Warehouse Receipt</small>
                                            </v-tooltip>
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <button @click="PRINT_PAGES(item.awb, index)"
                                                        type="button"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        class="btn btn-danger btn-m">
                                                        <small class="d-flex justify-content-center align-items-center">
                                                            <div class="spinner-border spinner-border-sm mb-0" role="status" v-if="print_pages.filter(e => e == index).length == 1">
                                                                <span class="sr-only">Loading...</span>
                                                            </div>
                                                            <i class="bi bi-newspaper" v-else></i>
                                                        </small>
                                                    </button>
                                                </template>
                                                <small>Imprimir TAG</small>
                                            </v-tooltip>
                                        </div>
                                    </template>
                                    <template v-slot:[`item.download`]="{ item, index }">
                                        <div class="d-flex">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <button @click="DOWNLOAD_PDF(item.awb, index)"
                                                        type="button"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        class="btn btn-success btn-m mr-1">
                                                        <small>
                                                            <div class="spinner-border spinner-border-sm mb-0" role="status" v-if="save_pdf.filter(e => e == index).length == 1">
                                                                <span class="sr-only">Loading...</span>
                                                            </div>
                                                            <i class="bi bi-file-pdf" v-else></i>
                                                        </small>
                                                    </button>
                                                </template>
                                                <small>Download PDF</small>
                                            </v-tooltip>
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <button @click="DOWNLOAD_EXCEL(item.awb, index)"
                                                        type="button"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        class="btn btn-success btn-m">
                                                        <small>
                                                            <div class="spinner-border spinner-border-sm mb-0" role="status" v-if="save_excel.filter(e => e == index).length == 1">
                                                                <span class="sr-only">Loading...</span>
                                                            </div>
                                                            <i class="bi bi-file-earmark-excel" v-else></i>
                                                        </small>
                                                    </button>
                                                </template>
                                                <small>Download XLS</small>
                                            </v-tooltip>
                                        </div>
                                    </template>
                                    <template v-slot:[`item.close`]="{ item }">
                                        <v-tooltip top v-if="globalViewOption('AwbUpdate')">
                                            <template v-slot:activator="{ on, attrs }">
                                                <button @click="ACTION(item)"
                                                    type="button"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    :disabled="role != 1 && item.state_id == 20"
                                                    class="btn btn-m" :class="item.state_id == 19 ? 'btn-danger' : 'btn-dark'">
                                                    <small><i :class="item.state_id == 19 ? 'bi bi-unlock' : 'bi bi-lock'"></i></small>
                                                </button>
                                            </template>
                                            <small>{{ item.state_id == 19 ? 'Cerrar' : 'Abrir' }}</small>
                                        </v-tooltip>
                                        <button class="btn btn-light btn-m" disabled v-else>
                                            <small><i :class="item.state_id == 19 ? 'bi bi-unlock' : 'bi bi-lock'"></i></small>
                                        </button>
                                    </template>
                                </v-data-table>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>
<script>
import ModalFilter from './modals/Filter'
import ModalDelete from './modals/Delete'
import ModalReload from './modals/Reload'
import { mapGetters } from 'vuex'
export default {
    components: { ModalFilter, ModalDelete, ModalReload },
    data() {
        return {
            headers: [
                { text: 'No.', value: 'id', sortable: false },
                { text: 'Número', value: 'awb', sortable: false },
                { text: 'Fecha', value: 'created_at', sortable: false },
                { text: 'Estado', value: 'state_id', sortable: false },
                { text: 'Ver', value: 'open', sortable: false },
                { text: 'Borrar', value: 'delete', sortable: false },
                { text: 'Imprimir', value: 'print', sortable: false },
                { text: 'Descargar', value: 'download', sortable: false },
                { text: 'Cerrar', value: 'close', sortable: false },
            ],
            items: {
                data: [],
                total: 0,
                to: 0
            },
            cancelToken: null,
            loading: '',
            print_wr: [],
            print_pages: [],
            save_pdf: [],
            save_excel: [],
            options: {},
            filter: {
                operator: 'LIKE',
                sortBy: 'created_at',
                sortDesc: 'DESC',
                fields: ['awb'],
                search: '',
            },
            onfilter: false,
            ondelete: false,
            onreload: false,
            id: null,
            item: null,
            count: 0,
        }
    },
    computed: {
        ...mapGetters([
            'role',
        ]),
        count_filter: function(){
            let count = 0;
            let vue = this
            Object.entries(vue.filter).forEach((e) => {
                if(e[0] != 'sortBy' && e[0] != 'sortDesc' && e[0] != 'search' && e[0] != 'loading'){
                    if(typeof e[1] == 'object'){
                        if(e[1]){
                            if(e[1].length > 0){
                                count++
                            }
                        }
                    }else{
                        if(e[1]){
                            count++
                        }
                    }   
                }
            })
            return count;
        }
    },
    methods: {
        INIT: function () {
            let vue = this
            const source = axios.CancelToken.source()
            vue.cancelToken = source
            const { page, itemsPerPage } = vue.options
            let query = {
                page: page,
                itemsPerPage: itemsPerPage,
            }
            Object.entries(vue.filter).forEach((e) => {
                query[e[0]] = e[1]
            })
            axios({
                url: '/awbs',
                method: 'GET',
                params: query,
                cancelToken: source.token,
            })
                .then((resp) => {
                    vue.items = resp.data
                    vue.loading = ''
                })
                .catch((err) => {
                    if (err.code !== 'ERR_CANCELED') {
                        if (err.response.status === 402) {
                            let message = err.response ? err.response.data.message : err.message
                            vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        } else {
                            vue.$swal({ toast: true, icon: 'error', title: err.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        }
                        vue.loading = ''
                    }
                })
        },
        SORT: function () {
            let vue = this
            if (vue.cancelToken) {
                vue.cancelToken.cancel("Solicitud cancelada");
            }
            vue.filter.sortDesc = vue.filter.sortDesc == 'ASC' ? 'DESC' : 'ASC'
            vue.loading = 'sort'
            vue.INIT()
        },
        ONFILTER: function(){
            let vue = this
            vue.onfilter = false
            vue.loading = 'table'
            if (vue.cancelToken) {
                vue.cancelToken.cancel("Solicitud cancelada");
            }
            vue.INIT()
        },
        FILTER: function () {
            let vue = this
            let count = 0
            if (vue.filter.search.length > 0) {
                count++
            }
            if (count > 0) {
                vue.loading = 'filter'
                if (vue.cancelToken) {
                    vue.cancelToken.cancel("Solicitud cancelada");
                }
                vue.INIT()
            }
        },
        CLEAR: function () {
            let vue = this
            vue.loading = 'clear'
            vue.filter = {
                operator: '==',
                sortBy: 'id',
                sortDesc: 'DESC',
                fields: ['id'],
                search: '',
                loading: '',
                state_id: [],
                payment_state_id: []
            }
            if (vue.cancelToken) {
                vue.cancelToken.cancel("Solicitud cancelada");
            }
            vue.INIT()
        },
        DELETE: function (id) {
            let vue = this
            vue.id = id
            vue.ondelete = true
        },
        PRINT: function(print, index){
            let vue = this
            if(vue.print_wr.filter(e => e == index).length == 0){
                vue.print_wr.push(index)
                axios({url: '/print/awb/' + print, method: 'GET', timeout: 60000, responseType: 'blob' })
                .then((response) => {
                    vue.print_wr.splice(vue.print_wr.findIndex(e => e == index), 1)
                    let link = document.createElement('a')
                    link.href = window.URL.createObjectURL(response.data)
                    link.target = '_blank'
                    link.rel = "noopener"
                    link.click()
                })
                .catch((err) => {
                    if (err.code === 'ECONNABORTED') {
                        axios({
                            url: '/job/print/awb/' + print,
                            method: 'GET' })
                        .then((resp) => {
                            vue.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                            vue.print_wr.splice(vue.print_wr.findIndex(e => e == index), 1)
                        })
                        .catch((err) => {
                            vue.print_wr.splice(vue.print_wr.findIndex(e => e == index), 1)
                        })
                    } else {
                        if (err.response.status === 402) {
                            let message = err.response ? err.response.data.message : err.message
                            vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        } else {
                            vue.$swal({ toast: true, icon: 'error', title: err.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        }
                        vue.print_wr.splice(vue.print_wr.findIndex(e => e == index), 1)
                    }
                })
            }
        },
        PRINT_PAGES: function(print, index){
            let vue = this
            if(vue.print_pages.filter(e => e == index).length == 0){
                vue.print_pages.push(index)
                axios({url: '/print/awb/' + print + '/packages', method: 'GET', timeout: 60000, responseType: 'blob' })
                .then((response) => {
                    vue.print_pages.splice(vue.print_pages.findIndex(e => e == index), 1)
                    let link = document.createElement('a')
                    link.href = window.URL.createObjectURL(response.data)
                    link.target = '_blank'
                    link.rel = "noopener"
                    link.click()
                })
                .catch((err) => {
                    if (err.code === 'ECONNABORTED') {
                        axios({
                            url: '/job/print/awb/' + print + '/packages',
                            method: 'GET' })
                        .then((resp) => {
                            vue.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                            vue.print_pages.splice(vue.print_pages.findIndex(e => e == index), 1)
                        })
                        .catch((err) => {
                            vue.print_pages.splice(vue.print_pages.findIndex(e => e == index), 1)
                        })
                    } else {
                        if (err.response.status === 402) {
                            let message = err.response ? err.response.data.message : err.message
                            vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        } else {
                            vue.$swal({ toast: true, icon: 'error', title: err.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        }
                        vue.print_pages.splice(vue.print_pages.findIndex(e => e == index), 1)
                    }
                })
            }
        },
        DOWNLOAD_PDF: function(print, index){
            let vue = this
            if(vue.save_pdf.filter(e => e == index).length == 0){
                vue.save_pdf.push(index)
                axios({url: '/print/awb/' + print+ '?type=pdf', method: 'GET', timeout: 60000, })
                .then((response) => {
                    vue.save_pdf.splice(vue.save_pdf.findIndex(e => e == index), 1)
                    var fileLink = document.createElement('a')
                    fileLink.href = 'data:application/pdf;base64,' + response.data.file
                    fileLink.setAttribute('download', response.data.filename)
                    document.body.appendChild(fileLink)
                    fileLink.click()
                })
                .catch((err) => {
                    if (err.code === 'ECONNABORTED') {
                        axios({
                            url: '/job/print/awb/' + print + '?type=pdf',
                            method: 'GET' })
                        .then((resp) => {
                            vue.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                            vue.save_pdf.splice(vue.save_pdf.findIndex(e => e == index), 1)
                        })
                        .catch((err) => {
                            vue.save_pdf.splice(vue.save_pdf.findIndex(e => e == index), 1)
                        })
                    } else {
                        if (err.response.status === 402) {
                            let message = err.response ? err.response.data.message : err.message
                            vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        } else {
                            vue.$swal({ toast: true, icon: 'error', title: err.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        }
                        vue.save_pdf.splice(vue.save_pdf.findIndex(e => e == index), 1)
                    }
                })
            }
        },
        DOWNLOAD_EXCEL: function(print, index){
            let vue = this
            if(vue.save_excel.filter(e => e == index).length == 0){
                vue.save_excel.push(index)
                axios({url: '/print/awb/' + print + '?type=excel', method: 'GET', timeout: 60000, })
                .then((response) => {
                    vue.save_excel.splice(vue.save_excel.findIndex(e => e == index), 1)
                    var fileLink = document.createElement('a')
                    fileLink.href = 'data:application/vnd.ms-excel;base64,' + response.data.file
                    fileLink.setAttribute('download', response.data.filename)
                    document.body.appendChild(fileLink)
                    fileLink.click()
                })
                .catch((err) => {
                    if (err.code === 'ECONNABORTED') {
                        axios({
                            url: '/job/print/awb/' + print + '?type=excel',
                            method: 'GET' })
                        .then((resp) => {
                            vue.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                            vue.save_excel.splice(vue.save_excel.findIndex(e => e == index), 1)
                        })
                        .catch((err) => {
                            vue.save_excel.splice(vue.save_excel.findIndex(e => e == index), 1)
                        })
                    } else {
                        if (err.response.status === 402) {
                            let message = err.response ? err.response.data.message : err.message
                            vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        } else {
                            vue.$swal({ toast: true, icon: 'error', title: err.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        }
                        vue.save_excel.splice(vue.save_excel.findIndex(e => e == index), 1)
                    }
                })
            }
        },
        base64toBlob: function (data) {
            const base64WithoutPrefix = data

            const bytes = atob(base64WithoutPrefix)
            let length = bytes.length
            let out = new Uint8Array(length)

            while (length--) {
                out[length] = bytes.charCodeAt(length)
            }

            return new Blob([out], { type: 'application/pdf' })
        },
        ACTION: function(item){
            let vue = this
            vue.item = item
            vue.onreload = true
        },
        FRESH: function(item){
            let vue = this
            vue.onreload = false
            let index = vue.items.data.findIndex(e => e.awb == item.awb)
            if(index != -1){
                if(vue.items.data[index].awb == item.awb){
                    vue.items.data[index].state_id = item.state_id
                }
            }
        }
    },
    watch: {
        options: {
            handler() {
                if (this.cancelToken) {
                    this.cancelToken.cancel("Solicitud cancelada");
                }
                this.loading = 'table'
                this.INIT()
            },
            deep: true
        }
    }
}
</script>
